import { useEffect } from 'react';

export const useOutsideClick = (
  ref: any,
  hasVisibleRef: boolean = false,
  onClickOut: () => void,
  classNameItemsToExclude: string[] = ['icon']
) => {
  useEffect(() => {
    const onClick = ({ target }: any) => {
      !ref?.contains(target) &&
        !target.classList.contains(classNameItemsToExclude) &&
        hasVisibleRef &&
        onClickOut?.();
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [onClickOut, ref, hasVisibleRef, classNameItemsToExclude]);
};
